import { PlusIcon } from "@images/svgIcons/plusIcon"
import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"
import { ThemeMode } from "@modules/ui/styles/theme"
import { useTheme } from "styled-components"

type AddBlockProps = {
  onAddExerciseBlock: () => void
  onAddCoachNoteBlock: () => void
  onAddAthleteNoteBlock: () => void
  onAddMediaBlock: () => void
} & React.HTMLAttributes<HTMLDivElement>

export const AddBlock: React.FC<AddBlockProps> = ({
  onAddExerciseBlock,
  onAddCoachNoteBlock,
  onAddAthleteNoteBlock,
  onAddMediaBlock,
  ...props
}) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column align-items-center card gap-3 p-3" {...props}>
      <div className="flex flex-column align-items-center">
        <HUText className="mb-1" fontStyle="LL">
          {word("sessionForm.blocks.add.title")}
        </HUText>
        <HUText fontStyle="BS" color={theme.neutralColor600}>
          {word("sessionForm.blocks.add.description")}
        </HUText>
      </div>

      <div className="flex flex-column w-full">
        <div className="flex align-items-center justify-content-around w-full gap-3 mt-3 text-center">
          <AddBlockItem label={word("sessionForm.blocks.add_workout.button")} onClick={onAddExerciseBlock} />
          <AddBlockItem label={word("sessionForm.blocks.add_note_for_coaches.button")} onClick={onAddCoachNoteBlock} />
        </div>

        <div className="flex align-items-center justify-content-around w-full gap-3 mt-3 text-center">
          <AddBlockItem
            label={word("sessionForm.blocks.add_note_for_athletes.button")}
            onClick={onAddAthleteNoteBlock}
          />
          <AddBlockItem label={word("sessionForm.blocks.add_media.button")} onClick={onAddMediaBlock} />
        </div>
      </div>
    </div>
  )
}

const AddBlockItem: React.FC<{ onClick: () => void; label: string }> = ({ onClick, label }) => {
  const theme = useTheme()
  const themeSpecificClass = theme.mode === ThemeMode.ATHLETE ? `hover:surface-200` : `hover:surface-100`

  return (
    <div
      className={`flex flex-column flex-1 py-2 align-items-center rounded-big-radius border-1 border-300 transition-duration-300 transition-all cursor-pointer gap-2 ${themeSpecificClass}`}
      onClick={onClick}
    >
      <div
        className="flex align-items-center justify-content-center p-2 border-circle"
        style={{
          width: 32,
          height: 32,
          backgroundColor: theme.mode === ThemeMode.ATHLETE ? theme.mainWhite : theme.neutralColor100,
        }}
      >
        <PlusIcon color={theme.blackAtheleWhiteOwner} width={14} height={14} />
      </div>

      <HUText fontStyle="LM">{label}</HUText>
    </div>
  )
}
